export function useSocialIcon() {
    const detectSocialIcon = (raw) => {
        if (!raw || raw.trim() === '') return null;

        let hostname
        try {
            const normalized = normalizeUrl(raw.trim())
            hostname = new URL(normalized).hostname.replace(/^www\./, '')
        } catch {
            return 'link.svg'
        }

        for (const social of SOCIALS_MAP) {
            if (social.keys.some(key => hostname === key || hostname.endsWith('.' + key))) {
                return social.icon
            }
        }
        return 'link.svg';
    }

    return { detectSocialIcon }
}

function normalizeUrl(raw) {
    if (!/^https?:\/\//i.test(raw)) {
        return 'https://' + raw
    }
    return raw
}

const SOCIALS_MAP = [
    {keys: ['instagram.com', 'instagr.am', 'inst.am'], icon: 'instagram.svg'},
    {keys: ['whatsapp.com', 'wa.me'], icon: 'whatsapp.svg'},
    {keys: ['facebook.com', 'fb.com', 'fb.me'], icon: 'facebook.svg'},
    {keys: ['x.com', 'twitter.com', 't.co'], icon: 'x.svg'},
    {keys: ['t.me', 'telegram.me', 'telegram.org'], icon: 'telegram.svg'},
    {keys: ['tiktok.com', 'vm.tiktok.com'], icon: 'tiktok.svg'},
    {keys: ['ok.ru', 'odnoklassniki.ru'], icon: 'ok.svg'},
    {keys: ['vk.com', 'vk.me'], icon: 'vk.svg'},
    {keys: ['linkedin.com', 'lnkd.in'], icon: 'linkedin.svg'},
    {keys: ['viber.com', 'viber.click', 'msng.link/vi'], icon: 'viber.svg'},
    {keys: ['pinterest.com', 'pin.it'], icon: 'pinterest.svg'},
    {keys: ['threads.net', 'threads.com'], icon: 'threads.svg'},
    {keys: ['discord.com', 'discord.gg'], icon: 'discord.svg'},
    {keys: ['behance.net'], icon: 'behance.svg'},
    {keys: ['dribbble.com'], icon: 'dribbble.svg'},
    {keys: ['slack.com'], icon: 'slack.svg'},
    {keys: ['dzen.ru', 'zen.yandex.ru'], icon: 'dzen.svg'},
    {keys: ['twitch.tv'], icon: 'twitch.svg'},
    {keys: ['github.com'], icon: 'github.svg'},
    {keys: ['reddit.com'], icon: 'reddit.svg'},
    {keys: ['tumblr.com'], icon: 'tumblr.svg'},
    {keys: ['youtube.com', 'youtu.be'], icon: 'youtube.svg'},
    {keys: ['olx.kz'], icon: 'olx.svg'},
    {keys: ['wb.ru', 'wildberries.ru'], icon: 'wb.svg'},
    {keys: ['ozon.kz'], icon: 'ozon.svg'},
    {keys: ['kaspi.kz'], icon: 'kaspi.svg'}
];
